export default {
  colors: {
    white: '#fff',
    black: '#202124',
    gray: [
      '#f8f9fa', // 0
      '#f1f3f5', // 1
      '#e9ecef', // 2
      '#dee2e6', // 3
      '#ced4da', // 4
      '#adb5bd', // 5
      '#868e96', // 6
      '#495057', // 7
      '#343a40', // 8
      '#212529', // 9
      '#f7f7f7', // 10

    ],
    blue: [
      '#e8f7ff', // 0
      '#ccedff', // 1
      '#a3daff', // 2
      '#72c3fc', // 3
      '#4dadf7', // 4
      '#329af0', // 5
      '#228ae6', // 6
      '#1c7cd6', // 7
      '#1b6ec2', // 8
      '#1862ab', // 9
    ],
    green: [
      '#ebfbee', // 0
      '#d3f9d8', // 1
      '#b2f2bb', // 2
      '#8ce99a', // 3
      '#69db7c', // 4
      '#51cf66', // 5
      '#40c057', // 6
      '#37b24d', // 7
      '#2f9e44', // 8
      '#2b8a3e', // 9
    ],
    yellow: [
      '#fff9db', // 0
      '#fff3bf', // 1
      '#ffec99', // 2
      '#ffe066', // 3
      '#ffd43b', // 4
      '#fcc419', // 5
      '#fab005', // 6
      '#f59f00', // 7
      '#f08c00', // 8
      '#e67700', // 9
    ],
    red: [
      '#fff5f5', // 0
      '#ffe3e3', // 1
      '#ffc9c9', // 2
      '#ffa8a8', // 3
      '#ff8787', // 4
      '#ff6b6b', // 5
      '#fa5252', // 6
      '#f03e3e', // 7
      '#e03131', // 8
      '#c92a2a', // 9
      '#722C33', // 10
    ],
  },
  layout: {
    containerMaxWidth: 960,
    containerMinWidth: 720,
    menuMinWidth: 767,
    menuHeight: 54,
  },
  font: {
    family: {
      sans: 'Plex, -apple-system, BlinkMacSystemFont, helvetica neue, helvetica, Ubuntu, roboto, noto, segoe ui, arial, sans-serif',
      mono: 'Monaco, Menlo, Courier New, Courier, monospace',
    },

    weight: {
      normal: 400,
      medium: 500,
      semibold: 600,
    },

    size: [
      '11px', // 0
      '12px', // 1
      '13px', // 2
      '14px', // 3
      '17px', // 4
      '21px', // 5
      '24px', // 6
      '36px', // 7
      '48px', // 8
    ],

    lineHeight: {
      none: '1.0',
      tight: '1.3',
      normal: '1.5',
      loose: '1.7',
    },
  },
  space: [
    '0', // 0
    '2px', // 1
    '4px', // 2
    '8px', // 3
    '16px', // 4
    '32px', // 5
    '64px', // 6
  ],
  transition: {
    default: '200ms ease',
  },
};
